@let headerVm = vm();

@if (headerVm.visible) {
  <header
    class="app-header"
    [class.app-header--brand]="headerVm.variant === 'brand'"
    [class.app-header--back]="headerVm.variant === 'back'"
    [class.app-header--close]="headerVm.variant === 'close'"
  >
    @if (headerVm.variant === 'brand') {
      <div class="app-header__slot app-header__slot--start"></div>

      <div class="app-header__brand">
        <img
          class="app-header__brand-logo"
          src="images/logo/logo.png"
          alt="Visionnaire"
        />
      </div>

      <button
        type="button"
        class="app-header__icon-button"
        aria-label="Notifications"
        (click)="onNotificationClick()"
      >
        <mat-icon>notifications_none</mat-icon>
      </button>
    } @else {
      <button
        type="button"
        class="app-header__nav-button"
        [attr.aria-label]="headerVm.variant === 'close' ? 'Close page' : 'Go back'"
        (click)="headerVm.variant === 'close' ? onCloseClick() : onBackClick()"
      >
        @if (headerVm.variant === 'close') {
          <mat-icon>close</mat-icon>
        } @else {
          <mat-icon>arrow_back</mat-icon>
        }
      </button>

      <div class="app-header__title-wrap">
        @if (headerVm.title) {
          <h1 class="app-header__title">
            @if (headerVm.isRaw) {
              {{ headerVm.title }}
            } @else {
              {{ headerVm.title | transloco }}
            }
          </h1>
        }
      </div>

      <div class="app-header__slot app-header__slot--end">
        @if (headerVm.actions.length) {
          @for (action of headerVm.actions; track action.icon) {
            <button
              type="button"
              class="app-header__icon-button"
              [attr.aria-label]="action.tooltipKey || action.icon"
              (click)="onActionClick(action)"
            >
              <mat-icon>{{ action.icon }}</mat-icon>

              @if (action.badgeCount && action.badgeCount > 0) {
                <span class="app-header__badge"></span>
              }
            </button>
          }
        }
      </div>
    }
  </header>
}
